import en from './translations/en';
import fa from './translations/fa';
export default {
    en,
    fa
}
